/**
 * Hero Slider Module
 *
 * Handles full-width hero slide carousel with auto-advance and arrow navigation.
 */

const DEFAULT_INTERVAL = 5000;

/**
 * Initialize a single hero slider
 */
function initSlider(slider) {
  const track = slider.querySelector(".hero-slider__track");
  const slides = track.querySelectorAll(".hero-slider__slide");
  const prevBtn = slider.querySelector(".hero-slider__arrow--prev");
  const nextBtn = slider.querySelector(".hero-slider__arrow--next");
  const totalSlides = slides.length;

  if (totalSlides === 0) {
    return;
  }

  let currentIndex = 0;
  let autoSlideInterval;

  /**
   * Navigate to a specific slide
   */
  function goToSlide(index) {
    currentIndex = index;
    slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === index);
    });
  }

  /**
   * Advance to the next slide
   */
  function nextSlide() {
    goToSlide((currentIndex + 1) % totalSlides);
  }

  /**
   * Go to previous slide
   */
  function prevSlide() {
    goToSlide((currentIndex - 1 + totalSlides) % totalSlides);
  }

  /**
   * Start auto-sliding
   */
  function startAutoSlide() {
    const interval = parseInt(slider.dataset.interval, 10) || DEFAULT_INTERVAL;
    autoSlideInterval = setInterval(nextSlide, interval);
  }

  /**
   * Stop auto-sliding
   */
  function stopAutoSlide() {
    clearInterval(autoSlideInterval);
  }

  // Initialize first slide as active
  if (slides.length > 0) {
    slides[0].classList.add("active");
  }

  // Arrow navigation
  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      stopAutoSlide();
      prevSlide();
      startAutoSlide();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      stopAutoSlide();
      nextSlide();
      startAutoSlide();
    });
  }

  // Touch/swipe support
  let touchStartX = 0;
  let touchStartY = 0;
  let isSwiping = false;

  slider.addEventListener(
    "touchstart",
    (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping = false;
      stopAutoSlide();
    },
    { passive: true },
  );

  slider.addEventListener(
    "touchmove",
    (e) => {
      if (!isSwiping) {
        const dx = Math.abs(e.touches[0].clientX - touchStartX);
        const dy = Math.abs(e.touches[0].clientY - touchStartY);
        if (dx > dy && dx > 10) {
          isSwiping = true;
        }
      }
      if (isSwiping) {
        e.preventDefault();
      }
    },
    { passive: false },
  );

  slider.addEventListener(
    "touchend",
    (e) => {
      const touchEndX = e.changedTouches[0].clientX;
      const diff = touchStartX - touchEndX;
      const threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }

      if (slider.dataset.autoSlide === "true") {
        startAutoSlide();
      }
    },
    { passive: true },
  );

  // Set up auto-slide with pause on hover
  if (slider.dataset.autoSlide === "true") {
    startAutoSlide();
    slider.addEventListener("mouseenter", stopAutoSlide);
    slider.addEventListener("mouseleave", startAutoSlide);
  }
}

/**
 * Initialize all hero sliders on the page
 */
export function init() {
  const sliders = document.querySelectorAll(".hero-slider");
  sliders.forEach(initSlider);
}
